export const CREATE_VTYPE = 'CREATE_VTYPE'
export const SAVED_VTYPE = 'SAVED_VTYPE'
export const SAVED_VTYPE_RES = 'SAVED_VTYPE_RES'
export const EDIT_VTYPE = 'EDIT_VTYPE'
export const UPDATE_VTYPE_LOC = 'UPDATE_VTYPE_LOC'
export const FETCH_VTYPE = 'FETCH_VTYPE'
export const FETCHED_VTYPE = 'FETCHED_VTYPE'
export const DELETE_VTYPE = 'DELETE_VTYPE'
export const DELETED_VTYPE = 'DELETED_VTYPE'
export const NOTIFICATION_DONE_VTYPE = 'NOTIFICATION_DONE_VTYPE'

